/* Built In Imports */

/* External Imports */
import { Box, Flex, Skeleton } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import MultimediaSlider from '@app-ps/Components/Banners/MultimediaSlider';
import PsBannerVideo from '@app-ps/Components/Banners/PsBannerVideo';
import TopBannerSimple from '@app-ps/Components/Banners/TopBannerSimple';
import TopBannerV2 from '@app-ps/Components/Banners/TopBannerV2';
import TopBannerVideo from '@app-ps/Components/Banners/TopBannerVideo';
import BlogCards from '@app-ps/Components/Card/BlogCards';
import Calendar from '@app-ps/Components/Card/Calendar';
import CardInfo2ColumnGroup from '@app-ps/Components/Card/CardInfo2ColumnGroup';
import ProductionVerticalList from '@app-ps/Components/Card/ProductionVerticalList';
import PsRelatedPost from '@app-ps/Components/Card/PsRelatedPost';
import SingleImage from '@app-ps/Components/Card/SingleImage';
import SectionTitle from '@app-ps/Components/Headings/SectionTitle';
import TopKolam from '@app-ps/Components/Headings/TopKolam';
import MidContainer from '@app-ps/Components/Layout/MidContainer';
import MediaEmbedV2 from '@app-ps/Components/Media/MediaEmbedV2';
import PsQuote from '@app-ps/Components/Quote/PsQuote';
import SamskritiQuote from '@app-ps/Components/Quote/SamskritiQuote';
import Gallery from '@app-ps/Components/Slider/Gallery';
import SingleLineText from '@app-ps/Components/Text/SingleLineText';
import SubscribeContent from '@app-ps/Components/Ui/SubscribeContent';
import BenefitsGroup from '@app-ps/Section/BenefitsGroup';
import CardProgram3ColumnGroup from '@app-ps/Section/CardProgram3ColumnGroup';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import { Suspense } from 'react';

/* Services */

/**
 * Renders the SectionUI on sectionId
 * @param {Object} sectionContent- Data for section
 * @param {Object} section
 * @returns {ReactElement} Designs SectionUI for children component
 */

const SectionUI = ({
  sectionContent,
  section,
  region,
  lang,
  pType,
  csrData,
  pageData,
  headerMenuData,
}) => {
  return (
    <Flex w="100%" flexDirection="column">
      {RenderComponents({
        sectionContent,
        region,
        lang,
        section,
        pType,
        pageData,
        csrData,
        headerMenuData,
      })}
    </Flex>
  );
};
const RenderComponents = ({
  sectionContent,
  region,
  lang,
  section,
  pType,
  pageData,
  csrData,
  headerMenuData,
}) => {
  // console.log('RenderComponents', sectionContent);
  switch (sectionContent._modelApiKey) {
    case 'section_title':
      return <SectionTitle titleObj={sectionContent} />;
    case 'top_kolam':
      return <TopKolam sectionContent={sectionContent} />;
    case 'top_banner_v2':
      return <TopBannerV2 sectionContent={sectionContent} />;
    case 'top_banner_simple':
      return <TopBannerSimple sectionContent={sectionContent} />;
    case 'multimedia_slider':
      return <MultimediaSlider sectionContent={sectionContent} />;
    case 'media_embed_v2':
      return (
        <Box
          width={{ base: '100%', lg: '755px' }}
          mx="auto"
          px={{ base: '16px', md: '0' }}
          mb={{ base: '20px', md: '40px' }}
        >
          <MediaEmbedV2
            sectionContent={sectionContent}
            lang={lang}
            region={region}
          />
        </Box>
      );

    case 'benefits_group':
      return (
        <BenefitsGroup
          region={region}
          lang={lang}
          sectionContent={sectionContent}
        />
      );
    case 'structured_text':
      return (
        <RenderStructuredText
          sectionContent={sectionContent}
          pageData={pageData}
          region={region}
          lang={lang}
        />
      );
    case 'single_image':
      if (sectionContent.fieldId === 'bottom-overlap') {
        return (
          <Box p="0" textAlign="center">
            <SingleImage
              sectionContent={sectionContent}
              region={region}
              lang={lang}
              display="flex"
              mt="0"
              mx="auto"
              width="100%"
              mb="-15px"
            />
          </Box>
        );
      }
      return (
        <Box p="0 25px" textAlign="center">
          <SingleImage
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            sectionContent={sectionContent}
            region={region}
            lang={lang}
            display="flex"
            mx="auto"
          />
        </Box>
      );
    case 'single_line_text':
      return (
        <SingleLineText
          sectionContent={sectionContent}
          lang={lang}
          region={region}
        />
      );
    case 'top_banner_video':
      if (sectionContent.style === 'ps-video-banner') {
        return (
          <PsBannerVideo
            sectionContent={sectionContent}
            region={region}
            lang={lang}
          />
        );
      }
      return (
        <TopBannerVideo
          pageData={pageData}
          sectionContent={sectionContent}
          headerMenuData={headerMenuData}
          region={region}
          lang={lang}
        />
      );

    case 'quote':
      if (sectionContent.decoration === 'ps-quote') {
        return <SamskritiQuote sectionContent={sectionContent} lang={lang} />;
      }
      return <PsQuote sectionContent={sectionContent} lang={lang} />;
    case 'card_program3_column_group':
      return (
        <CardProgram3ColumnGroup
          sectionContent={sectionContent}
          region={region}
          lang={lang}
        />
      );
    case 'card_info2_column_group':
      return (
        <CardInfo2ColumnGroup
          sectionContent={sectionContent}
          lang={lang}
          region={region}
        />
      );

    case 'newsletter_subscription_form':
      return (
        <SubscribeContent
          sectionContent={sectionContent}
          lang={lang}
          region={region}
        />
      );
    case 'project_samskriti_gallery':
      return (
        <Gallery sectionContent={sectionContent} lang={lang} region={region} />
      );
    case 'ps_upcoming_workshop_performance':
      // console.log('ps_upcoming_workshop_performance1', sectionContent);
      if (sectionContent.style === 'calendar') {
        return (
          <Suspense fallback={<Skeleton />}>
            <Calendar
              sectionContent={sectionContent}
              lang={lang}
              region={region}
            />
          </Suspense>
        );
      } else if (sectionContent.style === 'production-vertical-list') {
        return (
          <Suspense fallback={<Skeleton />}>
            <ProductionVerticalList
              sectionContent={sectionContent}
              lang={lang}
              region={region}
            />
          </Suspense>
        );
      } else {
        return <></>;
      }
    case 'ps_blog_listing_content':
      return (
        <BlogCards
          region={region}
          lang={lang}
          sectionContent={sectionContent}
        />
      );
    case 'ps_related_post':
      return (
        <PsRelatedPost
          sectionContent={sectionContent}
          lang={lang}
          region={region}
        />
      );
  }
};
export default SectionUI;

export const RenderStructuredText = ({
  sectionContent,
  region,
  lang,
  maxWidth,
}) => {
  return (
    <MidContainer w="620px" pt="15px">
      <Box
        sx={{
          h2: {
            fontSize: '26px',
          },
          h3: {
            fontSize: '18px',
          },
        }}
        px={{ base: '15px', md: '0' }}
        py={{ base: '0', md: '0' }}
        textAlign={
          sectionContent?.fieldId === 'center-align' ? 'center' : 'initial'
        }
      >
        <StructuredTextParser
          str={render(sectionContent.body)}
          region={region}
          lang={lang}
          textAlign={sectionContent.style}
          theme={
            sectionContent.style !== 'shivanga-white-txt' ? 'dark' : 'light'
          }
          maxWidth={'620px'}
        />
      </Box>
    </MidContainer>
  );
};
